import { render } from "./DesktopUploader.vue?vue&type=template&id=4eb22944"
import script from "./DesktopUploader.vue?vue&type=script&lang=js"
export * from "./DesktopUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__